'use strict';

angular.module('youth').directive('msSearchbar', ['$timeout', function ($timeout) {
  return {
    templateUrl: 'youth/templates/searchbar.html',
    restrict: 'E',
    scope: {},
    controllerAs: 'vm',
    controller: 'ActivitySearchCtrl',
    link: function link(scope, element) {
      element.find('input').bind('blur', function () {
        $timeout(function () {
          scope.focusState = false;
        }, 200);
      });
      element.find('input').bind('focus', function () {
        $timeout(function () {
          scope.focusState = true;
        }, 200);
      });
    }
  };
}]).controller('ActivitySearchCtrl', ['activitySvc', '$stateParams', '$state', '$timeout', 'NotifyingSvc', 'context', function (activitySvc, $stateParams, $state, $timeout, NotifyingSvc, context) {
  var vm = this;

  vm.search = function (query) {

    if (query === null || query.replace(/\s/g, '').length === 0) {
      return;
    }

    $state.go('activitySearchPage', {
      query: query
    });

    var searchBody = {
      query: query,
      context: context,
      filters: null
    };
    activitySvc.search(searchBody).then(function (resp) {
      vm.searchPending = false;
      vm.hits = resp.hits.total;
      vm.records = resp.hits.hits;

      document.activeElement.blur();

      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.SEARCH_RESULTS, {
        query: query,
        hits: resp.hits.total,
        records: resp.hits.hits
      });
    });
  };

  function _init() {
    if ($stateParams.query) {
      vm.searchTerms = $stateParams.query;
      vm.search($stateParams.query);
    }
  }

  $timeout(function () {
    _init();
  });
}]);